import Submit from './submit';
export default Submit;
